export default (json) => `
~~~json
${JSON.stringify(json, null, '\t')}
~~~`;
